export const EmptyFileUploaderItem = () => {
  return (
    <div className='flex min-h-20 items-center justify-center rounded-md border-2 border-dashed'>
      <p className='text-sm opacity-60'>Drop to add</p>
    </div>
  )
}
